import { gql } from 'urql';

//HardPull Polling
const GetVLocApplicationStatus = gql`
  query GetVLocApplicationStatus($statusInput: VLocApplicationStatusInput!) {
    getVLocApplicationStatus(input: $statusInput) {
      ... on VLocApplicationStatusSuccess {
        __typename
        applicationStatus
        approvedPageCopy {
          congratsText
          title
          description
          additionalQualifications
        }
      }

      ... on VLocApplicationStatusExistenceError {
        __typename
        code
        message
        title
      }
    }
  }
`;

export default GetVLocApplicationStatus;
